import { Component } from 'react'
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar'
import { isEmpty, isEqual } from 'lodash'
import moment from 'moment-timezone'
import $ from 'jquery'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fromZonedTime } from 'date-fns-tz'
import { startOfMonth, endOfMonth, subDays, addDays } from 'date-fns'
import { withTranslation } from 'react-i18next'

import { parseEventsForCalendar, getBlockedSlots, canIssueRefund } from '../../helpers/helpers'
import { CALENDAR_RANGE_PADDING_DAYS } from '../../helpers/constants'
import withHookSnackbar from '../../helpers/hooks/hocUseSnackbar'
import { selectUserData } from '../../reducers/userDataReducer'
import { selectActiveBuilding } from '../../reducers/buildingSelectorReducer'
import {
  setTrainingsDates,
  updateCalendarEvent,
  selectStartDate,
  selectEndDate,
} from '../../reducers/trainingsReducer'
import { startEditEvent } from '../../reducers/eventReducer'
import {
  cancelReservation,
  setBlockedDays,
  selectBlockedDays,
} from '../../reducers/Organisation/reservationsReducer'
import ConfirmPopup from '../Popups/ConfirmPopup'
import ConfirmPopupBody from '../Reservations/ReservationsList/ConfirmPopupBody'

import { getCalendarMessages } from './calendarMessages'
import MonthEvent from './MonthEvent'
import MonthReservationEvent from './MonthReservationEvent'
import WeekEvent from './WeekEvent'
import CalendarToolbar from './CalendarToolbar'
import CalendarCell from './CalendarCell'
import CalendarMonth from './CalendarMonth'
import DayEvent from './DayEvent'
import CalendarEventPopup from './CalendarEventPopup'
import CalendarAmenityPopup from './CalendarAmenityPopup'
import CalendarBlockedTimeslotPopup from './CalendarBlockedTimeslotPopup'
import AgendaEvent from './AgendaEvent'
import CalendarAgenda from './CalendarAgenda'
import AttendingModal from './AttendingModal'
import AgendaWithEmptyDays from './AgendaWithEmptyDays'
import { CalendarTimeBlockPopup } from './TimeBlocks/CalendarTimeBlockPopup'

class CalendarManagement extends Component {
  constructor(props) {
    super(props)
    const minTime = new Date()
    const maxTime = new Date()
    minTime.setHours(6, 0, 0)
    maxTime.setHours(23, 0, 0)
    this.state = {
      currentCalendarView: 'month',
      currentCalendarDay: new Date(),
      weekDayMin: minTime,
      weekDayMax: maxTime,
      event: {},
      eventPopup: {
        open: false,
        target: null,
      },
      attendingPopup: {
        event: null,
        open: false,
        type: '',
      },
      canceledReservation: null,
      refundState: 'refund',
      refundAmount: '',
      cancelNote: '',
      selectedDate: moment(),
    }
    this.currentDayDate = new Date()
    this.currentDayDate.setHours(0, 0, 0)
    this.showEventPopup = this.showEventPopup.bind(this)
    this.hideEventPopup = this.hideEventPopup.bind(this)
    this.handleEditEvent = this.handleEditEvent.bind(this)
    this.handleCancelReservationEvent = this.handleCancelReservationEvent.bind(this)
    this.displayTimeIndicator = this.displayTimeIndicator.bind(this)
    this.selectEvent = this.selectEvent.bind(this)
    this.handleOnView = this.handleOnView.bind(this)
    this.handleOnNavigate = this.handleOnNavigate.bind(this)
    this.filterTrainings = this.filterTrainings.bind(this)
    this.updateCalendarEvent = this.updateCalendarEvent.bind(this)
    this.openAttendingPopup = this.openAttendingPopup.bind(this)
    this.closeAttendingPopup = this.closeAttendingPopup.bind(this)
    this.onCancelReservation = this.onCancelReservation.bind(this)
    this.refetchEvents = this.refetchEvents.bind(this)
  }

  componentDidMount() {
    $(window).on('resize', () => {
      this.hideEventPopup()
    })
  }

  showEventPopup(event, target) {
    // nested setState because first popup will render it's width and height based on event object
    // and then can properly calculate position
    this.setState({ event }, () => {
      this.setState((prevState) => ({
        ...prevState,
        eventPopup: {
          open: true,
          target: target,
        },
      }))
    })
  }

  hideEventPopup() {
    this.setState((prevState) => ({
      ...prevState,
      event: {},
      eventPopup: {
        open: false,
        target: null,
      },
    }))
  }

  handleEditEvent(e, training) {
    e.preventDefault()
    const { dispatch, onEditEvent } = this.props
    dispatch(startEditEvent(training))
    onEditEvent()
  }

  handleCancelReservationEvent(e, reservation) {
    e.preventDefault()
    this.setState({
      canceledReservation: reservation,
      refundState: 'refund',
      refundAmount: '',
      cancelNote: '',
    })
  }

  displayTimeIndicator() {
    const { currentCalendarView, currentCalendarDay } = this.state
    if (!moment().isSame(currentCalendarDay, currentCalendarView)) {
      $('.rbc-current-time-indicator').addClass('is-hidden')
    } else {
      $('.rbc-current-time-indicator').removeClass('is-hidden')
    }
  }

  selectEvent(event, e) {
    const target = $(e.target).closest('.ctp-event')

    if (this.state.currentCalendarView === 'agenda') {
      const timeCell = $(e.target).closest('tr').find('.rbc-agenda-time-cell')
      if (timeCell.length > 0) {
        this.showEventPopup(event, timeCell)
        return
      }
    }

    this.showEventPopup(event, target)
  }

  handleOnView(e) {
    this.hideEventPopup()
    this.setState({ currentCalendarView: e }, () => {
      this.displayTimeIndicator()
    })
  }

  handleOnNavigate(e) {
    this.setState((prev) => ({ ...prev, selectedDate: moment(e) }))
    this.hideEventPopup()
    const { dispatch, userData, activeBuilding } = this.props

    const timezone =
      (userData.user.role === 'ShiftManager'
        ? userData.buildingId?.timezone
        : activeBuilding?.timezone) || 'America/Chicago'

    const start = fromZonedTime(
      subDays(startOfMonth(e), CALENDAR_RANGE_PADDING_DAYS),
      timezone,
    ).getTime()
    const end = fromZonedTime(
      addDays(endOfMonth(e), CALENDAR_RANGE_PADDING_DAYS),
      timezone,
    ).getTime()

    dispatch(setTrainingsDates(start, end))
    if (['ShiftManager'].includes(userData.user.role) || activeBuilding) {
      const buildingId =
        userData.user.role === 'ShiftManager' ? userData.buildingId.id : activeBuilding.id
      this.props.getTrainingsByBuildingId(start, end, buildingId)
      this.props.getReservationsByBuildingId(start, end, buildingId)
    }
    this.setState({ currentCalendarDay: e }, () => {
      this.displayTimeIndicator()
    })
  }

  filterTrainings(method) {
    const { data, filters, userData, activeBuilding } = this.props
    const eventType = filters.calendar.eventType
    const staffMemberFilter = filters.calendar['Staff Member']
    const chooseReservationFilter = filters.calendar['Choose Reservation']
    const classTypeFilter = filters.calendar['Class Type'].filter((type) =>
      eventType === 'all' ? true : eventType === 'appointment' ? type.personal : !type.personal,
    )
    const clientFilter = filters.calendar['Choose Client']
    const selectSpaceFilter = filters.calendar['Select Space']
    const chooseReservationFilterActive = chooseReservationFilter.length > 0

    let filteredData = data.slice()

    if (method === 'and') {
      if (staffMemberFilter.length > 0) {
        filteredData = filteredData.filter((training) => {
          const sel = staffMemberFilter.map((item) => item.id)
          return sel.includes(training.trainerId.id)
        })
      }
      if (chooseReservationFilter.length > 0) {
        filteredData = filteredData.filter((reservation) => {
          const sel = chooseReservationFilter.map((item) => item.id)
          return sel.includes(reservation.name)
        })
      }
      if (selectSpaceFilter.length > 0) {
        filteredData = filteredData.filter((reservation) => {
          return (
            reservation.locationId &&
            selectSpaceFilter.some((loc) => loc.id === reservation.locationId)
          )
        })
      }
      if (eventType !== 'appointment' && activeBuilding) {
        filteredData = filteredData.filter((training) => {
          return training.buildingId && activeBuilding.id === training.buildingId.id
        })
      }
      if (classTypeFilter.length > 0) {
        filteredData = filteredData.filter((training) => {
          const sel = classTypeFilter.map((item) => item.id)
          return sel.includes(training.type.id)
        })
      }
    } else if (method === 'or') {
      const staffMemberFilterActive = staffMemberFilter.length > 0
      const locationFilterActive = !!activeBuilding
      const classTypeFilterActive = classTypeFilter.length > 0
      const selectSpaceFilterActive = selectSpaceFilter.length > 0
      const clientFilterActive =
        userData.user.role === 'Trainer' && eventType === 'appointment' && clientFilter.length > 0

      const filteredByStaffMember = staffMemberFilterActive
        ? filteredData.filter((training) => {
            const sel = staffMemberFilter.map((item) => item.id)
            return sel.includes(training.trainerId.id)
          })
        : []
      const filteredByLocation = locationFilterActive
        ? filteredData.filter((training) => {
            return training.buildingId && activeBuilding.id === training.buildingId.id
          })
        : []
      const filteredByAmenity =
        chooseReservationFilterActive && !selectSpaceFilterActive
          ? filteredData.filter((reservation) => {
              const sel = chooseReservationFilter.map((item) => item.text)
              return reservation && sel.includes(reservation.name)
            })
          : []
      const filteredBySpace = selectSpaceFilterActive
        ? filteredData.filter((reservation) => {
            const matchesSpace =
              reservation.locationId &&
              selectSpaceFilter.some((loc) => loc.id === reservation.locationId)
            const matchesAmenity = chooseReservationFilterActive
              ? chooseReservationFilter.map((item) => item.text).includes(reservation.name)
              : true
            return matchesSpace && matchesAmenity
          })
        : []
      const filteredByClassType = classTypeFilterActive
        ? filteredData.filter((training) => {
            const sel = classTypeFilter.map((item) => item.id)
            return sel.includes(training.type.id)
          })
        : []
      const filteredByClient = clientFilterActive
        ? filteredData.filter((training) => {
            const filteredClientIds = clientFilter.map((item) => item.id)
            const trainingClientIds = training.clients.map((client) => client.id)
            return filteredClientIds.some((v) => trainingClientIds.includes(v))
          })
        : []

      const join = [
        ...filteredByStaffMember,
        ...filteredByLocation,
        ...filteredByClassType,
        ...filteredByClient,
        ...filteredByAmenity,
        ...filteredBySpace,
      ]

      const filtersActive =
        staffMemberFilterActive ||
        locationFilterActive ||
        chooseReservationFilterActive ||
        selectSpaceFilterActive ||
        classTypeFilterActive ||
        clientFilterActive

      const isSeveralArraysInArray =
        [
          filteredByStaffMember,
          filteredByLocation,
          filteredByClassType,
          filteredByClient,
          filteredByAmenity,
          filteredBySpace,
        ].filter((arr) => arr.length).length > 1

      filteredData = filtersActive
        ? join.length === 0
          ? []
          : locationFilterActive &&
              ['Administrator', 'PropertyManager', 'Manager', 'ShiftManager'].includes(
                userData.user.role,
              )
            ? join.filter((item, index, array) =>
                isSeveralArraysInArray || chooseReservationFilterActive
                  ? array.indexOf(item) !== index
                  : array.indexOf(item) === index,
              )
            : []
        : locationFilterActive || ['Trainer', 'ShiftManager'].includes(userData.user.role)
          ? filteredData
          : []
    }
    return filteredData
  }

  getBlockedTimeslots() {
    const { filters, blockedTimeslots, startDate, endDate, userData, dispatch, activeBuilding } =
      this.props

    const [blockedCalendarTimeslots, blockedCalendarDays, unavailableSlotDays] = getBlockedSlots(
      activeBuilding,
      userData,
      filters,
      blockedTimeslots,
      startDate,
      endDate,
    )
    !isEqual(this.props.blockedDays, blockedCalendarDays) &&
      dispatch(setBlockedDays(blockedCalendarDays))
    return [...blockedCalendarTimeslots, ...unavailableSlotDays]
  }

  updateCalendarEvent(event) {
    this.props.dispatch(updateCalendarEvent(event))
  }

  openAttendingPopup(e, type, event) {
    e.preventDefault()
    this.setState(
      (state) => ({
        ...state,
        attendingPopup: {
          eventId: event.id,
          open: true,
          type: type,
        },
      }),
      this.hideEventPopup,
    )
  }

  closeAttendingPopup(e) {
    e.preventDefault()
    this.setState({ attendingPopup: { eventId: null, open: false, type: '' } })
  }

  getViews(userRole) {
    return {
      month: CalendarMonth,
      agenda: ['Administrator', 'Trainer', 'Manager'].includes(userRole) ? CalendarAgenda : true,
      week: true,
      day: true,
    }
  }

  async onCancelReservation() {
    const { dispatch, onReservationCancel, displaySnackbar } = this.props
    const { canceledReservation, refundState, refundAmount, cancelNote } = this.state

    try {
      await dispatch(
        cancelReservation({
          reservationId: canceledReservation.id,
          refund: refundState !== 'no_refund',
          withoutStoreUpdate: true,
          cancelNote,
          ...(refundState === 'partial' && { amount: Number(refundAmount) }),
        }),
      )

      this.setState({
        canceledReservation: null,
        cancelNote: '',
        refundState: 'refund',
        refundAmount: '',
      })

      this.hideEventPopup()

      displaySnackbar(this.props.t('calendar:userPopup.cancelledSuccess'))

      if (onReservationCancel) {
        onReservationCancel()
      }
    } catch (err) {
      const message =
        err.response?.data?.message || this.props.t('calendar:userPopup.genericCancelError')
      displaySnackbar(message, true)
      console.error(err)
    }
  }

  closeConfirmationPopup() {
    this.setState({
      canceledReservation: null,
      cancelNote: '',
      refundState: 'refund',
      refundAmount: '',
    })
  }

  refetchEvents() {
    const { dispatch, fetchEvents, activeBuilding } = this.props
    const { selectedDate } = this.state
    const timezone = activeBuilding?.timezone || 'America/Chicago'
    const start = fromZonedTime(
      subDays(startOfMonth(selectedDate), CALENDAR_RANGE_PADDING_DAYS),
      timezone,
    ).getTime()
    const end = fromZonedTime(
      addDays(endOfMonth(selectedDate), CALENDAR_RANGE_PADDING_DAYS),
      timezone,
    ).getTime()

    fetchEvents(start, end)
    dispatch(setTrainingsDates(start, end))
  }

  render() {
    const filteredData = parseEventsForCalendar(
      [...this.getBlockedTimeslots(), ...this.filterTrainings('or')],
      true,
      this.state.currentCalendarView === 'day' || this.state.currentCalendarView === 'agenda',
    )
    const isRegularEvent = filteredData[0] && filteredData[0].type

    const {
      event,
      eventPopup,
      canceledReservation,
      refundState,
      refundAmount,
      cancelNote,
      currentCalendarView,
      weekDayMin,
      weekDayMax,
      attendingPopup,
    } = this.state
    // Pick the popup from the selected event, not the list: a toolbar tab switch only hides the
    // popup via CSS, so `event` can still be a reservation after the list switches to trainings.
    const isRegularEventSelected = isEmpty(event) ? isRegularEvent : !!event.type
    const { userData, activeBuilding, t } = this.props

    const timezone = activeBuilding?.timezone || userData?.buildingId?.timezone
    const isRefundAllowed = canIssueRefund(
      userData?.user?.role,
      canceledReservation?.date,
      timezone,
    )
    const cancelPaidReservationText =
      refundState === 'refund'
        ? t('calendar:userPopup.cancelPaidReservation')
        : refundState === 'partial'
          ? t('calendar:userPopup.cancelPartialRefund')
          : t('calendar:userPopup.cancelReservation')
    const declineFreeReservationText = t('calendar:userPopup.declineFreeReservation')
    const isCancelRefundInvalid = refundState === 'partial' && !Number(refundAmount)

    return (
      <div className={`ctp-calendar ctp-calendar--${currentCalendarView}`}>
        <BigCalendar
          localizer={momentLocalizer(moment)}
          selectable={currentCalendarView === 'month'}
          views={{
            month: true,
            agenda: ['Administrator', 'Trainer', 'Manager', 'PropertyManager'].includes(
              userData.user.role,
            )
              ? AgendaWithEmptyDays
              : false,
            week: true,
            day: true,
          }}
          defaultView={'month'}
          events={filteredData}
          date={this.state.selectedDate.toDate()}
          messages={getCalendarMessages(t)}
          components={{
            toolbar: CalendarToolbar,
            dateCellWrapper: CalendarCell,

            month: {
              event: isRegularEvent ? MonthEvent : MonthReservationEvent,
              month: CalendarMonth, // 👈
            },
            week: { event: WeekEvent },
            day: { event: DayEvent },
            agenda: {
              event: AgendaEvent,
              agenda: CalendarAgenda, // 👈
            },
          }}
          onSelectEvent={this.selectEvent}
          onSelectSlot={this.hideEventPopup}
          view={this.state.currentCalendarView}
          onView={this.handleOnView}
          onNavigate={this.handleOnNavigate}
          maxRows={99999}
          min={weekDayMin}
          max={weekDayMax}
          defaultDate={this.currentDayDate}
          length={7}
          popup={false}
          updateCalendarEvent={this.updateCalendarEvent}
        />
        {isRegularEventSelected ? (
          <CalendarEventPopup
            userRole={this.props.userData.user.role}
            event={event}
            open={eventPopup.open}
            target={eventPopup.target}
            onClose={this.hideEventPopup}
            onEditEvent={this.handleEditEvent}
            onCancelReservationEvent={this.handleCancelReservationEvent}
            updateCalendarEvent={this.updateCalendarEvent}
            openAttendingPopup={this.openAttendingPopup}
            refetchEvents={this.refetchEvents}
          />
        ) : ['unavailableSlot', 'phantomBooking'].includes(event.reservationType) ? (
          <CalendarBlockedTimeslotPopup
            userRole={this.props.userData.user.role}
            event={event}
            open={eventPopup.open}
            target={eventPopup.target}
            onClose={this.hideEventPopup}
          />
        ) : event.reservationType === 'timeBlock' ? (
          <CalendarTimeBlockPopup
            timeBlockId={event.id}
            open={eventPopup.open}
            target={eventPopup.target}
            onClose={this.hideEventPopup}
          />
        ) : (
          <CalendarAmenityPopup
            buildingData={this.props.activeBuilding}
            userData={this.props.userData}
            userRole={this.props.userData.user.role}
            event={event}
            open={eventPopup.open}
            target={eventPopup.target}
            onClose={this.hideEventPopup}
            onCancelReservationEvent={this.handleCancelReservationEvent}
            updateCalendarEvent={this.updateCalendarEvent}
            openAttendingPopup={this.openAttendingPopup}
          />
        )}
        {canceledReservation && (
          <ConfirmPopup
            title={t('calendar:userPopup.confirmationTitle')}
            cancelText={t('common:actions.cancel')}
            confirmText={
              canceledReservation.chargeAmount > 0
                ? cancelPaidReservationText
                : declineFreeReservationText
            }
            confirmDisabled={isCancelRefundInvalid}
            isOpen={!!canceledReservation}
            body={
              <ConfirmPopupBody
                title={
                  canceledReservation.chargeAmount > 0
                    ? t('calendar:userPopup.reservationBody')
                    : t('calendar:userPopup.declineReservationBody')
                }
                shouldRenderRefundOptions={canceledReservation.chargeAmount > 0}
                allowPartialRefund
                refundBlocked={!isRefundAllowed}
                paidAmount={canceledReservation.chargeAmount}
                refundState={refundState}
                refundAmount={refundAmount}
                cancelNote={cancelNote}
                onRefundStateChange={(e) => this.setState({ refundState: e.target.value })}
                onRefundAmountChange={(value) => this.setState({ refundAmount: value })}
                onCancelNoteChange={(e) => this.setState({ cancelNote: e.target.value })}
              />
            }
            cancelCallback={() => this.closeConfirmationPopup()}
            confirmCallback={this.onCancelReservation}
          />
        )}
        <AttendingModal
          event={filteredData.find((event) => event.id === attendingPopup.eventId)}
          isOpen={attendingPopup.open}
          closePopup={this.closeAttendingPopup}
          type={attendingPopup.type}
        />
      </div>
    )
  }
}

CalendarManagement.propTypes = {
  calendar: PropTypes.object,
  userData: PropTypes.object,
  dispatch: PropTypes.func,
  startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  filters: PropTypes.object,
  data: PropTypes.array,
  blockedDays: PropTypes.array,
  blockedTimeslots: PropTypes.array,
  getTrainingsByBuildingId: PropTypes.func,
  getReservationsByBuildingId: PropTypes.func,
  updateCalendarEvent: PropTypes.func,
  onReservationCancel: PropTypes.func,
  onEditEvent: PropTypes.func,
  fetchEvents: PropTypes.func,
  activeBuilding: PropTypes.object,
  displaySnackbar: PropTypes.func,
  t: PropTypes.func,
}

export default withHookSnackbar(
  connect((state) => ({
    userData: selectUserData(state),
    startDate: selectStartDate(state),
    endDate: selectEndDate(state),
    blockedDays: selectBlockedDays(state),
    activeBuilding: selectActiveBuilding(state),
    ...state,
  }))(withTranslation(['calendar'])(CalendarManagement)),
)
